import React from 'react'
import { t } from 'i18next'
import { Color } from '../../Common/Color'
import { SafeHtml } from '../../Common/Common'
import dayjs from 'dayjs'

export default function BoxInactive ({ box }) {
  const defaultMessage = (
    <>
      <div style={cssTitle}>
        {t('Public.BoxPage.inactive.title')}
      </div>
      <div style={cssText}>
        {t('Public.BoxPage.inactive.description',
          {
            name: `${box.name} - ${box.zip_code}`,
            date: box.opening_date ? dayjs(box.opening_date).format('dddd DD MMMM') : "d'ici quelques jours"
          }
        )}
      </div>
    </>
  )

  return (
    <div style={cssPage}>
      <div className="contentPadding" style={cssCard}>
        {box.announcement_html
          ? <SafeHtml as='div' html={box.announcement_html} style={cssText} />
          : defaultMessage}
      </div>
    </div>
  )
}

const cssPage = {
  backgroundColor: Color.white,
  display: 'flex',
  justifyContent: 'center',
  padding: '3em 1em'
}

const cssCard = {
  backgroundColor: Color.white,
  border: `2px solid ${Color.dark_blue}`,
  borderRadius: '30px',
  maxWidth: '900px',
  padding: '2em',
  width: '100%'
}

const cssTitle = {
  fontSize: '30px',
  fontWeight: 'bold',
  marginBottom: '0.5em'
}

const cssText = {
  fontSize: '18px'
}
